import { BodyLong, Heading, Link, Table, VerticalSpace } from '@elhub/ds-components'

import React from 'react'
import ReactJson from 'react-json-view'

const json = {
  meta: {
    created: '2023-12-12T12:29:16+01:00',
    lastUpdated: '2023-12-12T12:29:16+01:00'
  },
  links: {
    self: 'https://api.elhub.no/energy-data/v0/consumption-groups'
  },
  data: [
    {
      type: 'consumption-groups',
      id: 'primary',
      attributes: {
        name: 'Primary Industry',
        description: 'All agriculture, forestry, fishing incl green houses, Division code 1-3 + Y'
      }
    },
    {
      type: 'consumption-groups',
      id: 'secondary',
      attributes: {
        name: 'Secondary Industry',
        description: 'All industry section codes B through F'
      }
    },
    {
      type: 'consumption-groups',
      id: 'tertiary',
      attributes: {
        name: 'Tertiary Service',
        description: 'All section codes G through U'
      }
    },
    {
      type: 'consumption-groups',
      id: 'household',
      attributes: {
        name: 'Household',
        description:
          'Meteringpoints that either have NACE Code XX (Household) or a combination of NACE Code 68.201 (House cooperative) and Consumption Code 35 (Households)'
      }
    },
    {
      type: 'consumption-groups',
      id: 'cabin',
      attributes: {
        name: 'Cabins and holiday properties',
        description: 'Cabins and vacation homes nace XY'
      }
    }
  ]
}

const attributes = [
  { Attribute: 'id', Type: 'String', Description: 'Unique identifier of the consumption group' },
  { Attribute: 'name', Type: 'String', Description: 'Consumption group name' },
  { Attribute: 'description', Type: 'String', Description: 'Consumption group description' }
]

const ConsumptionGroups = () => {
  return (
    <>
      <Heading>Consumption groups</Heading>
      <BodyLong size='small'>
        Endpoint to get the list of all consumption group available to query on the entities (price-areas /
        grid-areas).
      </BodyLong>
      <VerticalSpace />
      <BodyLong size='small'>
        <b>Use the following endpoint:</b>{' '}
        <Link variant='primary' href='https://api.elhub.no/energy-data/v0/consumption-groups'>
          https://api.elhub.no/energy-data/v0/consumption-groups
        </Link>
      </BodyLong>
      <VerticalSpace />
      <BodyLong size='small'>Sample response:</BodyLong>
      <ReactJson src={json} collapsed name={false} sortKeys />
      <VerticalSpace />
      <Table size='small'>
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeader scope='col'>Attribute</Table.ColumnHeader>
            <Table.ColumnHeader scope='col'>Type</Table.ColumnHeader>
            <Table.ColumnHeader scope='col'>Description</Table.ColumnHeader>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {attributes.map(({ Attribute, Type, Description }) => (
            <Table.Row key={Attribute}>
              <Table.HeaderCell scope='row'>{Attribute}</Table.HeaderCell>
              <Table.DataCell>{Type}</Table.DataCell>
              <Table.DataCell>{Description}</Table.DataCell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </>
  )
}

export default ConsumptionGroups
